import { Table, TableBody, TableCell, TableHead, TableRow } from '@trackman/web-shared-components';
import { clubs, clubsNamesMapper } from 'utilities/clubNamesMapper';

import { Input } from '@trackman/web-shared-components';
import { TourAveragesParameter } from 'types/admin/tourAverages';
import { ReactComponent as TrashIcon } from 'images/icons/Trash.svg';
import { observer } from 'mobx-react-lite';
import { unitNamesMapper } from 'utilities/unitNamesMapper';
import { useStores } from 'index';

type Props = {
  kind: string;
  tourAveragesScoresArray: TourAveragesParameter[];
  handleDeleteColumn: (index: number) => void;
};

export const TourAveragesTable = observer(({ kind, tourAveragesScoresArray, handleDeleteColumn }: Props) => {
  const ps = useStores().parametersStore;

  return (
    <div className='tmu-table-wrapper pga-table'>
      <div className='table-header'>
        <div className='table-title'>
          <h2>{kind} TOUR DATA</h2>
        </div>
      </div>
      <Table className='tmu-table admin-table'>
        <TableHead>
          <TableRow>
            <TableCell width='200px'> </TableCell>
            {tourAveragesScoresArray.map((parameterData, index) => {
              const foundParam = ps.parametersList.find((param) => parameterData.parameterId === param.id);
              parameterData.parameterName = foundParam ? foundParam.title : '';
              return (
                <TableCell key={parameterData.parameterId} width='200px'>
                  <div className='column-data-wrapper'>
                    <div className='parameter-info'>
                      <div className='parameter-name'>{parameterData.parameterName}</div>
                      {parameterData.unit ? <div className='parameter-unit'>({unitNamesMapper(parameterData.unit)})</div> : null}
                    </div>
                    <button className='delete-button' onClick={() => handleDeleteColumn(index)}>
                      <TrashIcon />
                    </button>
                  </div>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {tourAveragesScoresArray.length ? (
            clubs.map((club) => (
              <TableRow hover tabIndex={-1} key={club}>
                <TableCell width='200px'>{clubsNamesMapper(club)}</TableCell>
                {tourAveragesScoresArray.map((parameterData, colIndex) => {
                  return (
                    <TableCell key={parameterData.parameterId} width='200px'>
                      <Input
                        type='text'
                        label=''
                        value={tourAveragesScoresArray[colIndex]?.clubs[club] ?? ''}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          e.currentTarget.value = e.currentTarget.value.replace(',', '.').replace(/[^0-9.-]/g, '');
                          if (tourAveragesScoresArray[colIndex]) {
                            tourAveragesScoresArray[colIndex].clubs[club] = e.currentTarget.value;
                          }
                        }}
                      />
                    </TableCell>
                  );
                })}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell>No data to show</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
});

export default TourAveragesTable;
